import { apiClient } from '@/api/client';
import type { PromptKind, SystemPromptModel } from '@/types/categories.types';

/** Superadmin-only endpoints (`app-superadmin`). */
export const promptsApi = {
  // GET /prompts/{key} — the raw template as stored, with the shipped default.
  getPrompt: async (kind: PromptKind): Promise<SystemPromptModel> => {
    const { data } = await apiClient.get<SystemPromptModel>(`/prompts/${kind}`);
    return data;
  },

  // PUT /prompts/{key} → 200; 1–20000 characters, nothing else validated.
  updatePrompt: async (kind: PromptKind, text: string): Promise<SystemPromptModel> => {
    const { data } = await apiClient.put<SystemPromptModel>(`/prompts/${kind}`, { text });
    return data;
  },
};
